var app = {
  colourScheme: 'blue',
  markerColour: 'blue',
  geocodeResults : {
    goodmanProperties: {},
    addresses: {}
  },
  saveToSmartSpace: false,
  currencyConversions: {},
  colorChanged: false
};

require([
  "esri/identity/OAuthInfo",
  "esri/identity/IdentityManager",
  "esri/config",
  "esri/views/MapView",
  "esri/Map",
  "esri/WebMap",
  "esri/layers/FeatureLayer",
  "esri/layers/GraphicsLayer",
  "esri/Graphic",
  "esri/geometry/Polygon",
  "esri/geometry/Point",
  "esri/widgets/Expand",
  "esri/widgets/Zoom",
  "esri/widgets/BasemapGallery",
  "esri/widgets/Home",
  "esri/request",
  "esri/geometry/geometryEngine",
  "esri/tasks/support/FeatureSet",
  "esri/tasks/QueryTask",
  "esri/tasks/support/Query",
  "esri/core/watchUtils"
],function(
  OAuthInfo,
  esriId,
  esriConfig,
  MapView,
  Map,
  WebMap,
  FeatureLayer,
  GraphicsLayer,
  Graphic,
  Polygon,
  Point,
  Expand,
  Zoom,
  BasemapGallery,
  Home,
  esriRequest,
  geometryEngine,
  FeatureSet,
  QueryTask,
  Query,
  watchUtils
) {

  // Set the portal and proxy
  try{
    esriConfig.portalUrl = config.portalUrl;

    var info = new OAuthInfo({
      appId: config.appId,
      portalUrl: config.portalUrl,
      popup: false
    });
    esriId.registerOAuthInfos([info]);
    app.esriId = esriId;

  } catch(error) {
    console.error("There was a problem logging in to the application on SmartSpace", error);
  }

  app.webmap = new WebMap({
    portalItem: {
      id: config.webMapID
    }
  });

  app.webmap.load()
    .then(function(){
      console.log("Successfully loaded the web map");
    })
    .catch(function(error){
      console.error("The resource failed to load: ", error);
      $.growl.error({ message: "The resource failed to load" });
      $("#viewDiv").hide();
      $("#error").show();
      $("#loading").hide();
    });

  app.view = new MapView({
    map: app.webmap,
    center: config.center,
    zoom: config.zoom,
    container: "viewDiv"
  });
  app.view.ui.components = [ "attribution" ];

  // Once the user logs in successfully...
  app.view.when(function(){

    setup();

    app.view.popup.highlightEnabled = false;
    // Ensure that the popup is directly shown over Goodman properties, by
    // manually moving it where applicable
    app.view.popup.watch("visible", function(visible) {
      if (visible) {
        setTimeout(function(){
          try{
            var latitude, longitude;
            var zoom = Math.max(app.view.zoom, config.zoomScale);
            if (app.view.popup.content !== null && app.view.popup.content.graphic !== undefined){
              latitude = app.view.popup.content.graphic.attributes.lat;
              longitude = app.view.popup.content.graphic.attributes.lon;
              if (!latitude) {
                latitude = app.view.popup.content.graphic.geometry.latitude;
              }
              if (!longitude){
                longitude = app.view.popup.content.graphic.geometry.longitude;
              }
              app.view.popup.location.latitude = latitude;
              app.view.popup.location.longitude = longitude;
            } else {
              latitude = app.view.popup.location.latitude;
              longitude = app.view.popup.location.longitude;
            }
            app.view.goTo({
              center: [longitude, latitude],
              zoom: zoom
            });
          } catch(err){
            console.error("There was a problem adjusting the view to the popup's location")
          }
        }, 100);
      }
    });

    // Modify the widgets to match the designs
    setTimeout(function(){

      // Home widget
      $(".esri-icon-home").hide();
      $(".esri-home").addClass('esri-square').append('<img src="./images/Home.svg" style="width: 92px;">');

      // Zoom buttons
      $(".esri-icon-plus").hide();
      $("div[title='Zoom In']").addClass('esri-square').append('<img src="./images/Plus.svg" style="width: 92px;">').css('margin-bottom', '8px');
      $(".esri-icon-minus").hide();
      $("div[title='Zoom Out']").addClass('esri-square').append('<img src="./images/Minus.svg" style="width: 92px;">')

      // Basemap gallery
      $(".esri-icon-basemap").hide();
      $("div[title='Expand the basemap gallery']").addClass('esri-circle').append('<img id="imgBasemaps" src="./images/Basemap.svg" style="width: 92px;">');
      $(".esri-widget--button").css("display", "flex");
      
      // Paintbrush icon
      var btnHtml = '<div class="esri-component esri-widget">';
      btnHtml += '<div id="btnPaint" class="esri-widget--button esri-widget esri-interactive esri-circle" role="button" title="Change the map styles">';
      btnHtml += '<img id="imgPaintbrush" src="./images/Paint.svg" style="width: 92px;"></div></div>';
      $(".esri-ui-top-left").append(btnHtml);
      $("#btnPaint").on('click', function(){
        // $('#paintModal').modal('show');
        $('#paintExpand').toggle();
        app.basemapExpand.collapse();
      });


      // Widget to switch color config
      $(".btnPaintPolygon").on("click", function(evt){
        try{
          app.colorChanged = true;
          app.colourScheme = $(this).data('colour');
          // $(".imgPaintPolygon").removeClass("active");
          // $(this).find('.imgPaintPolygon').addClass("active");
          
          $('.btnPaintPolygon').removeClass('active');
          $(this).addClass('active');

          // Update any existing polygons. They must be removed from the map and re-added in reverse
          // order to ensure that larger polygons draw underneath
          app.webmap.remove(app.polygonLayer);
          app.webmap.remove(app.propertyLayer);
          app.webmap.remove(app.markerLayer);
          if (app.polygonLayer.graphics.items.length > 0) {
            var graphics = app.polygonLayer.graphics.clone().items.reverse();
            app.polygonLayer.removeAll();
            var newGraphics = [];
            for (var a = 0; a < graphics.length; a++) {
              var graphic = graphics[a];
              graphic.symbol.color = config.colourSchemes[app.colourScheme][a];
              graphic.symbol.outline = config.colourOutlineSchemes[app.colourScheme][a];
              newGraphics.unshift(graphic);
            }

            for (var b = 0; b < newGraphics.length; b++) {
              app.polygonLayer.graphics.add(newGraphics[b]);
            }

          }
          setTimeout(function(){
            // For some reason it's necessary to pause briefly before re-adding the layer
            app.webmap.add(app.polygonLayer);
            app.webmap.add(app.propertyLayer);
            app.webmap.add(app.markerLayer);
          }, 200);
        } catch (err) {
          $.growl.error({ message: "There was a problem changing the colour scheme" });
        }
      });

      $(".btnPaintMarker").on("click", function(evt){
        // $(".imgPaintMarker").removeClass("active");
        // $(this).find('.imgPaintMarker').addClass("active");

        $('.btnPaintMarker').removeClass('active');
        $(this).addClass('active');

        app.webmap.remove(app.markerLayer);
        app.markerColour = $(this).data('colour');
        app.markerSymbol = {
          type: "picture-marker",
          url: "./images/Pin_" + app.markerColour + ".svg",
          width: "24px",
          height: "24px"
        };
        if (app.markerLayer.graphics.items.length > 0) {
          var graphics = app.markerLayer.graphics.clone().items;
          app.markerLayer.removeAll();
          var newGraphics = [];
          for (var a = 0; a < graphics.length; a++) {
            var graphic = graphics[a];
            graphic.symbol = app.markerSymbol;
            newGraphics.push(graphic);
          }

          for (var b = 0; b < newGraphics.length; b++) {
            app.markerLayer.graphics.add(newGraphics[b]);
          }

        }
        setTimeout(function(){
          // For some reason it's necessary to pause briefly before re-adding the layer
          app.webmap.add(app.markerLayer);
        }, 200);
      });

      // Save polygons icon
      var btnHtml = '<div class="esri-component esri-widget">';
      btnHtml += '<div id="btnSaveToSmartSpace" class="esri-widget--button esri-widget esri-interactive esri-circle" role="button" title="Save to SmartSpace">';
      btnHtml += '<img id="imgSaveToSmartSpace" src="./images/Save.svg" style="width: 92px;"></div></div>';
      $(".esri-ui-top-left").append(btnHtml);
      $("#btnSaveToSmartSpace").click(function(){
        $('#saveToSmartSpaceModal').modal('show');
      });

      // Run the report when the button is clicked
      $("#btnExportToSmartSpace").click(function(evt){

        var layerName = $("#txtSmartSpaceLayer").val();   //.replace(/\s/g,'_');
        layerName = layerName.replace(/[-|&;$%@"<>()+--, ]/g, "_");
        // mockSaveToSmartSpace();
        checkLayerName(layerName);

      });

      // Display the widget buttons
      $(".esri-widget--button").css("display", "flex");

      // display the sidebar then adjust the width to fit the scrollbars (if present)
      $("#sidebar-wrapper").fadeIn('slow');
      
      setupTourSplash();

    }, 3000);

  }, function(error){
   console.error("There was a problem logging in to the map");
   $.growl.error({ message: "There was a problem logging in to the map" });
   $("#loading").hide();
  });

  function calculateRings() {
    $("#btnCreateReport").addClass("disabled btn-clear").removeClass('btn-blue');
    $("#btnCalculate").addClass("disabled");
    $("#btnCalculate").prop("disabled", true);
    app.distanceMode = "rings";

    toastr.options.positionClass = "toast-center toast-with-backdrop toast-text-bolder toast-large toast-no-button";
    toastr.options.closeButton = false;
    toastr.options.timeOut = 0;
    toastr.options.extendedTimeOut = 0;
    toastr.info("Calculating rings...");
    
    try{

      // Remove any previous graphics
      app.polygonLayer.graphics.removeAll();

      // Disable the Step 3 button
      $(".btnStep3").addClass("disabled");
      $(".btnStep3").attr("disabled", true);

      // Remove the ability to click on the map to select an address
      if (app.viewClickListener !== undefined){
        app.viewClickListener.remove();
      }

      // Set a definition query to show only the selected facility, or none in the case of address searches
      if (app.startLocation.mode === 'address') {
        app.propertyLayer.definitionExpression = 'objectid = -9999';
      } else if (app.startLocation.objectid !== undefined) {
        app.propertyLayer.definitionExpression = 'objectid = ' + app.startLocation.objectid;
        // Update 17/8: Revert back to not change to reverse white
        app.propertyLayer.renderer = app.propertiesRendererHighlight;
        // Need to change the marker layer as well or else there would be distortion on the white goodman logo
        // Only happens when click from search results / mode = Goodman, else graphics would have 0 items
        let goodmanMarkerGraphic = app.markerLayer.graphics.getItemAt(0);
        if(goodmanMarkerGraphic){
          goodmanMarkerGraphic.symbol = {
            type: 'simple-marker',
            size: '0px'
          };
        }
      }

      app.webmap.remove(app.polygonLayer);
      var buffDistances = [];
      app.distanceUnits = $('#cboRingsUnits option:selected').val();
      for (var i = 1; i < 4; i++){
        var val = $("#txtRings" + i).val();
        if (val !== '') {
          val = parseInt(val);
          // if (app.distanceUnits === 'miles') {
          //   val = val * 1.60934
          // }
          buffDistances.push(val);
        }
      }

      // Sort the polygons so they are coloured properly. The polyGraphics array is used
      // to ensure that the largest polygons go underneath
      buffDistances = buffDistances.sort((a, b) => a - b);
      var polyGraphics = [];
      for (var x=0; x < buffDistances.length; x++){
        var buffDist = buffDistances[x];
        var buffer = geometryEngine.geodesicBuffer(app.startLocation.geometry, buffDist, 'kilometers');
        var polygon = new Polygon({
          rings: buffer.rings,
          spatialReference: buffer.spatialReference
        });

        var symbol = {
          type: "simple-fill",
          color: app.startLocation.mode === 'address' || app.colorChanged
            ? config.colourSchemes[app.colourScheme][x] 
            : config.colourSchemes['neonGreen'][x],
          outline: app.startLocation.mode === 'address' || app.colorChanged
            ? config.colourOutlineSchemes[app.colourScheme][x]
            : config.colourOutlineSchemes['neonGreen'][x]
        }

        console.log(symbol)

        var polyGraphic = new Graphic({
          type: 'polygon',
          geometry: polygon,
          symbol: symbol,
          attributes: {
            "name": "buffer_" + buffDist,
            "ToBreak": buffDist,
            "FromBreak": 0
          }
        });
        polyGraphics.unshift(polyGraphic);

        // zoom to the largest buffer
        if (x == (buffDistances.length - 1)) {app.view.goTo(polyGraphic);}

      }
      for (var p=0; p < polyGraphics.length; p++){
        app.polygonLayer.add(polyGraphics[p]);
      }

      // Update marker layer

      // Put the polygon layer underneath the marker layer
      app.webmap.remove(app.markerLayer);
      app.webmap.remove(app.propertyLayer)
      app.webmap.remove(app.polygonLayer);
      app.webmap.add(app.polygonLayer);
      app.webmap.add(app.markerLayer);
      app.webmap.add(app.propertyLayer)
        // Enable Step 3
      enableStep(3);

      closeGrowl();

      // Enable the Save To SmartSpace functionality if this user can access the functionality
      if (app.saveToSmartSpace){
        $("#btnSaveToSmartSpace").show();
      }

      // Set the default output name to the search location. Replace any illegal characters
      $("#txtSmartSpaceLayer").val(app.startLocation.attributes.name.replace(/[-|&;$%@"<>()+--, ]/g, "_"));

      $("#btnCreateReport").removeClass("disabled btn-clear").addClass('btn-blue');
      $("#btnCalculate").removeClass("disabled");
      $("#btnCalculate").prop("disabled", false);

    } catch(err) {
      console.error("There was a problem calculating the buffer rings");
      closeGrowl();
      toastr.error("There was a problem calculating the buffer rings");
      $("#loading").hide();
      $("#btnSaveToSmartSpace").hide();
      $("#btnCreateReport").addClass("disabled btn-clear").removeClass('btn-blue');
    }

  }

  function calculateDrivetimes(){
    console.log("Calculate drive times");
    $("#btnCreateReport").addClass("disabled btn-clear").removeClass('btn-blue');
    $("#btnCalculate").addClass("disabled");
    $("#btnCalculate").prop("disabled", true);
    app.distanceMode = "drivetime";

    toastr.options.positionClass = "toast-center toast-with-backdrop toast-text-bolder toast-large toast-no-button";
    toastr.options.closeButton = false;
    toastr.options.timeOut = 0;
    toastr.options.extendedTimeOut = 0;
    toastr.info("Calculating drive-times...");
    // try{

      // Remove any previous graphics
      app.polygonLayer.graphics.removeAll();

      // Disable the Step 3 button
      $(".btnStep3").addClass("disabled");
      $(".btnStep3").attr("disabled", true);

      // Remove the ability to click on the map to select an address
      if (app.viewClickListener !== undefined){
        app.viewClickListener.remove();
      }

      // Set a definition query to show only the selected facility, or none in the case of address searches
      if (app.startLocation.mode === 'address') {
        app.propertyLayer.definitionExpression = 'objectid = -9999';
      } else if (app.startLocation.objectid !== undefined) {
        app.propertyLayer.definitionExpression = 'objectid = ' + app.startLocation.objectid;
        // Update 17/8: Revert back to not change to reverse white
        app.propertyLayer.renderer = app.propertiesRendererHighlight;
        // Need to change the marker layer as well or else there would be distortion on the white goodman logo
        // Only happens when click from search results / mode = Goodman, else graphics would have 0 items
        let goodmanMarkerGraphic = app.markerLayer.graphics.getItemAt(0);
        if(goodmanMarkerGraphic){
          goodmanMarkerGraphic.symbol = {
            type: 'simple-marker',
            size: '0px'
          };
        }
      }

      // Figure out which travel mode to use
      var measure;
      app.vehicle = $("#carMode").hasClass('active') ? 'Car' : 'Truck';
      var mode;
      app.distanceUnits = $('#cboDrivetimeUnits option:selected').val();

      if (['mins', 'hours'].includes(app.distanceUnits)){
        mode = 'Time';
      } else {
        mode = 'Distance';
      }

      // Retrieve the travel mode parameters from the JSON file, which was obtained by querying the server
      // (see https://developers.arcgis.com/rest/services-reference/solve-service-area.htm)
      var travelMode = travelModes[app.vehicle + " " + mode];

      // Calculate the intervals
      var driveTimeCutoffs = [];
      for (var i = 1; i < 4; i++){
        var val = $("#txtDrivetime" + i).val();
        if (val !== '') {
          val = parseInt(val);
          driveTimeCutoffs.push(val);
        }
      }
      driveTimeCutoffs = driveTimeCutoffs.sort((a, b) => b - a);

      // Execute the service area task - this function calculates the drivetime polygons
      app.webmap.remove(app.polygonLayer);

      var facilities =new FeatureSet({
        features: [app.startLocation]
      });

      var break_units = 'Minutes';
      if (app.distanceUnits === 'km') {
        break_units = "Kilometers";
      } else if (app.distanceUnits === 'miles') {
        break_units = "Miles";
      } else if (app.distanceUnits === 'hours') {
        break_units = "Hours";
      }

      // Getting the parameters right for the drivetime query is a bit tricky. Use the values at
      // https://developers.arcgis.com/rest/network/api-reference/service-area-asynchronous-service.htm#
      // and stringify any compound parameters
      var data = {
        break_units: break_units,
        f: 'json',
        break_values: driveTimeCutoffs.toString().replace(/,/g, ' '),
        travel_direction: "away from facility",
        facilities: JSON.stringify(facilities),
        outSpatialReference: JSON.stringify({latestWkid: 3857,wkid: 102100}),
        travel_mode: JSON.stringify(travelMode),
        polygon_overlap_type: 'Disks'
      }

      // Add the travel time, if applicable
      if (app.vehicle === 'Car' && $(".traffic_checkbox").hasClass('checked')) {
        var dayOfWeek = $("#cboDayOfWeek").val();
        var timeOfDay = $("#cboTimeOfDay").val();

        // Convert the date to milliseconds: https://stackoverflow.com/a/9229384/906814
        var startDate = new Date(dayOfWeek + "T" + timeOfDay);
        var withOffset = startDate.getTime();
        var offset = startDate.getTimezoneOffset() * 60 * 1000;
        var unixTimestamp = withOffset - offset;
        data.time_of_day = unixTimestamp;
      }

      // Send the request to the asynchronous drivetime server
      $.ajax({
        url: config.serviceAreaUrl + "submitJob",
        data: data,
        type: 'POST',
        datatype: 'json',
        contentType: 'application/x-www-form-urlencoded'
      }).done(function(response) {
        // The response contains the ID of the job. Poll the server every second until the job
        // finishes or fails

        // Use the following pattern to check the inputs, using the parameters (eg Facilities) from https://developers.arcgis.com/rest/network/api-reference/service-area-asynchronous-service.htm#
        var url = config.serviceAreaUrl + '/jobs/';
        console.log(url + response.jobId + '/inputs/time_of_day?f=json');

        app.serviceAreaJobID = response.jobId;
        app.serviceAreaTimer = setInterval(() => {
          checkResultsStatus();
        }, 3000); // give arcgis time to responde
      }).catch((err) => {
        try{
            clearInterval(app.serviceAreaTimer);
            $("#btnCreateReport").addClass("disabled btn-clear").removeClass('btn-blue');
        } catch (err) {
          closeGrowl();
          console.error("There was a problem with the drive time analysis", err);
          toastr.error("There is an issue with the drive time calculations. Please try using distance rings");
          $("#btnCreateReport").addClass("disabled btn-clear").removeClass('btn-blue');
        }

        closeGrowl();

        if (err.message !== undefined && err.message === "Rate limit exceeded. Please try again later.") {
          console.error("There is an issue with the drive time calculations", err);
          toastr.error("There is an issue with the drive time calculations. Please try using distance rings");
          $("#btnCreateReport").addClass("disabled btn-clear").removeClass('btn-blue');
        } else {
          console.error("There was a problem with the drive time analysis", err);
          toastr.error("There is an issue with the drive time calculations. Please try using distance rings");
          $("#btnCreateReport").addClass("disabled btn-clear").removeClass('btn-blue');
        }
      });

  }

  function checkResultsStatus() {
    // Check on the status of the drivetime area job
    console.log("Check results status for job ID", app.serviceAreaJobID);
    esriRequest(config.serviceAreaUrl + "jobs/" + app.serviceAreaJobID + "?f=json")
      .then((response) => {
          var status = response.data.jobStatus;
          if (status === 'esriJobSucceeded') {
            // Fetch the resulting polygons
            clearInterval(app.serviceAreaTimer);

            esriRequest(config.serviceAreaUrl + "jobs/" + app.serviceAreaJobID + "/results/service_areas?returnMessages=true&f=json")
              .then((response) => {
                  // Di
                  var features = response.data.value.features;

                  // Sort the polygons so they are coloured properly. The polyGraphics array is used
                  // to ensure that the largest polygons go underneath
                  app.polyGraphics = [];

                  // Draw each service area polygon
                  features.reverse().forEach(function(graphic, index){
                    graphic.symbol = {
                      type: "simple-fill",
                      color: app.startLocation.mode === 'address' || app.colorChanged
                        ? config.colourSchemes[app.colourScheme][index] 
                        : config.colourSchemes['neonGreen'][index],
                      outline: app.startLocation.mode === 'address' || app.colorChanged
                        ? config.colourOutlineSchemes[app.colourScheme][index]
                        : config.colourOutlineSchemes['neonGreen'][index]
                      // outline: {
                      //   width: 0
                      // }
                    }
                    graphic.geometry.type = 'polygon'
                    app.polyGraphics.unshift(graphic);
                    console.log(graphic)
                    $("#loading").hide();
                  });

                  // Add the polygons
                  for (var p=0; p < app.polyGraphics.length; p++){
                    app.polygonLayer.add(app.polyGraphics[p], 0);
                  }

                  // Add and move layers so the point layers are on top
                  app.webmap.remove(app.polygonLayer);
                  app.webmap.remove(app.propertyLayer);
                  app.webmap.remove(app.markerLayer);
                  app.view.goTo(app.polygonLayer.graphics.items[0]);
                  app.webmap.add(app.polygonLayer);
                  app.webmap.add(app.markerLayer);
                  app.webmap.add(app.propertyLayer)

                  // Enable Step 3
                  enableStep(3);
                  closeGrowl();

                  // Enable the Save To SmartSpace functionality if this user can access the functionality
                  if (app.saveToSmartSpace){
                    $("#btnSaveToSmartSpace").show();
                  }

                  // Set the default output name to the search location
                  $("#txtSmartSpaceLayer").val(app.startLocation.attributes.name.replace(/[-|&;$%@"<>()+--, ]/g, "_"));
                  $("#btnCreateReport").removeClass("disabled btn-clear").addClass('btn-blue');
                  $("#btnCalculate").removeClass("disabled");
                  $("#btnCalculate").prop("disabled", false);

                }).catch((err) => {
                  try{
                    clearInterval(app.serviceAreaTimer);
                  } catch (err) {
                    closeGrowl();
                    console.error("There was a problem with the drive time analysis", err);
                    toastr.error("There is an issue with the drive time calculations. Please try using distance rings");
                    $("#btnSaveToSmartSpace").hide();
                    $("#btnCreateReport").addClass("disabled btn-clear").addClass('btn-blue');
                  }
                  closeGrowl();
                  if (err.message !== undefined && err.message === "Rate limit exceeded. Please try again later.") {
                    console.error(err.message);
                    toastr.error("There is an issue with the drive time calculations. Please try using distance rings");
                    $("#btnSaveToSmartSpace").hide();
                    $("#btnCreateReport").addClass("disabled btn-clear").addClass('btn-blue');
                  } else {
                    console.error("There was a problem with the drive time analysis", err);
                    toastr.error("There is an issue with the drive time calculations. Please try using distance rings");
                    $("#btnSaveToSmartSpace").hide();
                    $("#btnCreateReport").addClass("disabled btn-clear").addClass('btn-blue');
                  }
                });

          } else if (status === 'esriJobFailed') {
            clearInterval(app.serviceAreaTimer);
            var messages = response.data.messages;
            $.each(messages, function( index, message ) {
              console.log(message.description)
            });
            closeGrowl();
            console.error("There was a problem with the drive time analysis");
            toastr.error( "Please try a shorter drive time calculation");
            $("#btnSaveToSmartSpace").hide();
            $("#btnCreateReport").addClass("disabled btn-clear").addClass('btn-blue');

          } else {
            // console.log(status)
          }

        }).catch((err) => {
          try{
            clearInterval(app.serviceAreaTimer);
          } catch (err) {
            closeGrowl();
            console.error("There was a problem with the drive time analysis", err);
            toastr.error("There is an issue with the drive time calculations. Please try using distance rings");
            $("#btnSaveToSmartSpace").hide();
            $("#btnCreateReport").addClass("disabled btn-clear").addClass('btn-blue');
          }
          closeGrowl();
          if (err.message !== undefined && err.message === "Rate limit exceeded. Please try again later.") {
            console.error(err.message);
            $("#btnSaveToSmartSpace").hide();
            toastr.error("There is an issue with the drive time calculations. Please try using distance rings");
            $("#btnCreateReport").addClass("disabled btn-clear").addClass('btn-blue');
          } else {
            console.error("There was a problem with the drive time analysis", err);
            toastr.error("There is an issue with the drive time calculations. Please try using distance rings");
            $("#btnCreateReport").addClass("disabled btn-clear").addClass('btn-blue');
            $("#btnSaveToSmartSpace").hide();
          }
        });

  }

  function closeGrowl(){
    try {
      toastr.options.positionClass = "toast-top-left toast-have-button";
      toastr.options.closeButton = true;
      toastr.options.timeOut = 5000;
      toastr.options.extendedTimeOut = 1000;
      toastr.clear();
    } catch(err) {
      console.error("There was a problem closing the notification")
    }
  }

  function setup() {
    toastr.options.positionClass = "toast-top-left toast-have-button";
    toastr.options.closeButton = true;
    toastr.options.tapToDismiss = false;


    toastr.options.onShown = function() { console.log('hello'); }
    toastr.options.onHidden = function() { console.log('goodbye'); }
    toastr.options.onclick = function() { console.log('clicked'); }
    toastr.options.onCloseClick = function() { console.log('close button clicked'); }

    // set some default marker symbols
    app.markerSymbol = {
      type: "picture-marker",
      url: "./images/Pin_" + app.markerColour + ".svg",
      width: "24px",
      height: "24px"
    };

    app.goodmanSymbol = {
      type: "picture-marker",
      url: config.goodmanIcon,
      width: "36px",
      height: "36px"
    };

    app.goodmanSymbolHighlight = {
      type: "picture-marker",
      url: config.goodmanIconWhite,
      width: "36px",
      height: "36px"
    };

    // Add graphics layers for the address marker and drivetime/rings
    app.markerLayer = new GraphicsLayer({
      title: "markerLayer"
    });
    app.polygonLayer = new GraphicsLayer({
      // opacity: 0.75,
      // Changing the opacity at the color rgba will have the desired color stacking effect
      // https://developers.arcgis.com/javascript/latest/visualization/high-density-data/opacity/#how-per-feature-opacity-works
      title: "polygonLayer"
    });
    app.webmap.add(app.markerLayer);
    app.webmap.add(app.polygonLayer);

    app.propertiesRenderer = {
      type: "simple",
      symbol: app.goodmanSymbol
    };

    app.propertiesRendererHighlight = {
      type: "simple",
      symbol: app.goodmanSymbolHighlight
    };

    // Configure the Handlebars template for the Property layer's popup
    var source = document.getElementById("property-popup-template").innerHTML;
    var template = Handlebars.compile(source);

    // Add the properties point layer
    app.propertyLayer = new FeatureLayer({
      url: config.propertyLayerURL,
      outFields: '*',
      popupEnabled: true,
      popupTemplate: {
        title: null,
        content: template()
      },
      renderer: app.propertiesRenderer,
      definitionExpression: config.propertyLayerBaseQuery
    });
    app.webmap.add(app.propertyLayer);

    app.view.popup.dockOptions = {
      // Disable the dock button so users cannot undock the popup
      buttonEnabled: false,
      dockEnabled: false
    };
    app.view.popup.actions = [];

    // Display the loading indicator when the view is updating
    watchUtils.whenTrue(app.view, "updating", function(evt) {
      $("#loading").show();
    });

    // Hide the loading indicator when the view stops updating
    watchUtils.whenFalse(app.view, "updating", function(evt) {
      $("#loading").hide();
    });

    // OLD: Update the distance mode selector
    // $("#btnDistanceMode").click(function(evt){
    //   console.log("change distance mode");
    //   var currentMode = $(this).data('mode');
    //   if (currentMode === 'Car'){
    //     $(this).data('mode', 'Truck');
    //     $("#imgDistanceMode").attr("src","./images/Truck_hero.png");
    //     app.distanceMode = 'Truck';

    //     // Time of day is not applicable for trucks
    //     $("#useTraffic").addClass("disabled");
    //     $("#cboDayOfWeek").prop("disabled", true);
    //     $("#cboTimeOfDay").prop("disabled", true);

    //     // But remove the disabled class on the dropdowns to avoid doubling the opacity
    //     $("#timeOfDay").removeClass('disabled');
    //   } else {
    //     $(this).data('mode', 'Car');
    //     app.distanceMode = 'Car';
    //     $("#imgDistanceMode").attr("src","./images/Car_hero.png");

    //     // Set the disabled status of the traffic dropdowns to match the checkbox
    //     $("#useTraffic").removeClass("disabled");
    //     if ($('.traffic_checkbox').is('.checked')) {
    //       $("#timeOfDay").removeClass('disabled');
    //       $("#cboDayOfWeek").prop("disabled", false);
    //       $("#cboTimeOfDay").prop("disabled", false);
    //     } else {
    //       $("#timeOfDay").addClass('disabled');
    //       $("#cboDayOfWeek").prop("disabled", true);
    //       $("#cboTimeOfDay").prop("disabled", true);
    //     }
    //   }
    // });

    // NEW: distance mode selector
    $("#carMode").click(function(evt){
      // Set truck button inactive
      $(this).addClass('active');
      $("#truckMode").removeClass('active');
      app.distanceMode = 'Car';

      // Set the disabled status of the traffic dropdowns to match the checkbox
      $("#useTraffic").removeClass("disabled");
      if ($('.traffic_checkbox').is('.checked')) {
        $("#timeOfDay").removeClass('disabled');
        $("#cboDayOfWeek").prop("disabled", false);
        $("#cboTimeOfDay").prop("disabled", false);
      } else {
        $("#timeOfDay").addClass('disabled');
        $("#cboDayOfWeek").prop("disabled", true);
        $("#cboTimeOfDay").prop("disabled", true);
      }
    });

    
    $("#truckMode").click(function(evt){
      // Set car button inactive
      $(this).addClass('active');
      $("#carMode").removeClass('active');
      app.distanceMode = 'Truck';

      // Time of day is not applicable for trucks
      $("#useTraffic").addClass("disabled");
      $("#cboDayOfWeek").prop("disabled", true);
      $("#cboTimeOfDay").prop("disabled", true);

      // But remove the disabled class on the dropdowns to avoid doubling the opacity
      $("#timeOfDay").removeClass('disabled');
    });
    // Address search
    $("#btnSearch").on('click', function(evt){
      if (app.tour !== undefined){app.tour.end();}
      runAddressSearch($("#txtSearch").val());
    });

    $('#txtSearch').on('typeahead:selected', function(evt, item) {
      $("#txtSearch").val(item);
    });

    $('#txtSearch').on('click', function(evt) {
      $('#txtSearch').val('');
    })

    // Calculate the drive times
    // $("#btnCalculateDrivetimes").click(function(evt){
    //   if (app.tour !== undefined){app.tour.end();}
    //   calculateDrivetimes();
    // });

    // // Calculate rings
    // $("#btnCalculateRings").click(function(evt){
    //   if (app.tour !== undefined){app.tour.end();}
    //   calculateRings();
    // });
    // UPDATE 20/7/22: share calculate btn
    $("#btnCalculate").on('click',function(evt){
      if (app.tour !== undefined){app.tour.end();}
      let mode = $('#drivetime-tab').hasClass('active') ? 'drive' : 'ring';
      if(mode === 'drive'){
        calculateDrivetimes();
      } else {
        calculateRings();
      }
    });

    // Run the report when the button is clicked
    $("#btnCreateReport").click(function(evt){
      if (app.tour !== undefined){app.tour.end();}
      geoenrich();
    });

    // Display the tour with the Information button is pressed
    $("#btnTour").click(function(evt){
      $("#tourSplash").modal('show');
    });

    // Test whether the side panel is showing scrollbars, and adjust the width if so
    $(window).resize(function() {
      checkScrollbars();
    });

    // Adjust the height of the wrapper when the Rings vs Drivetime buttons are chosen. This is super dodgy, but needs must.....
    $("#ring-tab").on("click", function(){
      $("#sidebar-wrapper").removeClass("expanded");
      $("#sidebar-wrapper").addClass("shrunken");
      setTimeout(function(){
        checkScrollbars();
      }, 200);
    });

    $("#drivetime-tab").on("click", function(){
      $("#sidebar-wrapper").removeClass("shrunken");
      $("#sidebar-wrapper").addClass("expanded");
      setTimeout(function(){
        checkScrollbars();
        setTimeout(function(){
          checkScrollbars();
        }, 400);
      }, 200);
    });

    // Clear the inputs when the button is clicked
    $("#btnReset").on('click', function(evt){
      toastr.warning("Resetting. Search for an address or click on the map to start");
      app.markerLayer.removeAll();
      app.polygonLayer.removeAll();
      //app.searchWidget.clear();
      app.view.popup.close();
      $("#txtSearch").val('');
      enableStep(1);

      // Remove the Save To SmartSpace function
      $("#btnSaveToSmartSpace").hide();

      // Remove the definition query
      app.propertyLayer.definitionExpression = config.propertyLayerBaseQuery;
      app.propertyLayer.renderer = app.propertiesRenderer
      if (app.startLocation && app.startLocation.objectid !== undefined){
        delete app.startLocation.objectid;
      }

      // Reverse-geocode the address when clicking on the map
      if (app.viewClickListener !== undefined){
        app.viewClickListener.remove();
      }
      app.viewClickListener = app.view.on("click", function(event) {
        viewClick(event);
      });

      // Reset the DriveTime button status
      $("#btnCreateReport").removeClass("btn-blue").addClass('btn-clear');
      $("#drivetime-tab").removeClass('disabled');
      $("#drivetime-tab").removeAttr('disabled', 'disabled');
    });

    // layer list widget
    // var legend = new Expand({
    //   expandIconClass: "esri-icon-feature-layer",
    //   expandTooltip: "Expand the Legend",
    //   view: app.view,
    //   content: new Legend({
    //     view: app.view
    //   })
    // });
    // app.view.ui.add(legend, "top-right");

    // Home widget
    var homeWidget = new Home({
      view: app.view,
      iconClass: 'homeXX'
    });
    app.view.ui.add(homeWidget, "top-left");

    // Zoom widget. We create this manually so it can easily go after the Home widget
    var zoomWidget = new Zoom({
      view: app.view
    });
    app.view.ui.add(zoomWidget, "top-left");

    // Basemap gallery widget
    app.basemapGallery = new BasemapGallery({
      view: app.view
    });

    var basemapExpand = new Expand({
      expandIconClass: "esri-icon-basemap",
      expandTooltip: "Expand the basemap gallery",
      view: app.view,
      content: app.basemapGallery
    });

    app.basemapExpand = basemapExpand;

    app.view.ui.add(basemapExpand, {
      position: "top-left"
    });

    watchUtils.once(app.basemapGallery.source.basemaps,"length", function(state){
      // based on clues at https://community.esri.com/thread/217248-how-do-i-remove-basemaps-from-the-default-47-basemapgallery
      setTimeout(function(){

        // Sort the basemaps by title order
        var basemaps = app.basemapGallery.source.basemaps.clone().items;
        var basemapObj = {};
        var basemapTitles = [];
        for (var i = 0; i < basemaps.length; i++){
          var basemap = basemaps[i];
          var title = basemap.portalItem.title;
          basemapObj[title] = basemap;
          basemapTitles.push(title);
        }
        basemapTitles = basemapTitles.sort();

        // Remove the existing basemaps
        app.basemapGallery.source.basemaps.removeAll()

        // Add the basemaps back in the correct order
        for (var j = 0; j < basemapTitles.length; j++) {
          app.basemapGallery.source.basemaps.add(basemapObj[basemapTitles[j]]);
        }
      }, 200);
    });

    // Custom search widget, based on TypeAhead

    // Initialize the Bloodhound engine, used in the address searching
    app.geocodeBloodhoundEngine = new Bloodhound({
      datumTokenizer: function(datum) {
        return Bloodhound.tokenizers.whitespace(datum.value);
      },
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      limit: 4,
      valueKey: "text",
      remote: {
        url: config.suggestionsUrl + '?f=json&maxSuggestions=4&category=Address%2CCountry%2CCity%2CRegion%2CZone%2CSubregion%2CPostal%2CPopulated%20Place&text=%QUERY',
        wildcard: '%QUERY',
        transform: function(response) {
          return $.map(response.suggestions, function(address) {
            // Save the magic key so we can obtain the lat/long quickly
            var text = address['text'];
            if (app.geocodeResults.addresses[text] === undefined) {
              app.geocodeResults.addresses[text] = {
                magicKey: address.magicKey
              }
            }
            return text;
          });
        }
      }
    });
    app.geocodeBloodhoundEngine.initialize();

    // Initialise a second Bloodhound engine against the Goodman properties layer
    app.goodmanBloodhoundEngine = new Bloodhound({
      datumTokenizer: function(datum) {
        return Bloodhound.tokenizers.whitespace(datum.value);
      },
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      limit: 150,
      remote: {
        url: config.searchLayerURL,
        wildcard: '%QUERY',
        prepare: function(query, settings) {
          // Format the query for ArcGIS Server

          // Calculate the outfields
          var outFields = config.searchFields.toString();
          outFields += "," + config.searchLayerLatField + "," + config.searchLayerLonField;
          settings.url += "query?f=json&outFields=" + outFields;
          settings.url += "&returnGeometry=false&where=displayonglobal='1'+AND+upper(" + config.searchLayerNameField + ")+like+upper(%27%25" + query + "%25%27)";
          settings.url += "&token=" + app.token;
          return settings;
        },
        transform: function(response) {
          return $.map(response.features, function(feature) {
            // Save the details for later retrieval when the address is selected
            var name = feature.attributes[config.searchLayerNameField];
            if (app.geocodeResults.goodmanProperties[name] === undefined) {
              app.geocodeResults.goodmanProperties[name] = {}
              for (var prop in feature.attributes) {
                app.geocodeResults.goodmanProperties[name][prop] = feature.attributes[prop];
              }
            }

            // Store the address
            var addr = null;
            for (var a = 1; a < config.searchFields.length - 2; a++){
              var addrComponent = feature.attributes[config.searchFields[a]];
              if (addrComponent !== undefined && addrComponent !== null && addrComponent !== ''){
                if (addr === null) {
                  addr = addrComponent;
                } else {
                  addr += " " + addrComponent;
                }
              }
            }
            app.geocodeResults.goodmanProperties[name]["address"] = addr;

            // Calculate the 2-digit country code from the country name
            var country = feature.attributes[config.searchLayerCountryField] || '';
            var countryJSON = countryLookup.find(o => o.name === country);
            var countryCode = countryJSON ? countryJSON['alpha-2'] : '';

            app.geocodeResults.goodmanProperties[name]["countryCode"] = countryCode;

            return name;
          });
        }
      }
    });
    app.goodmanBloodhoundEngine.initialize();

    // Hook up both Bloodhounds to the search box
    $('#txtSearch').typeahead({
      hint: true,
      highlight: true,
    },
    {
      name: 'geocode',
      display: 'addresses',
      source: app.geocodeBloodhoundEngine,
      templates: {
        // Insert the green marker icon before the address
        suggestion: function(el){
          return '<p><span><img class="geocodeImagePin" src="./images/Location.svg"/>'+el + "</span></p>"}
      }
    },
    {
      name: 'goodman',
      display: 'Goodman properties',
      source: app.goodmanBloodhoundEngine,
      templates: {
        // Insert the Goodman icon before the property name
        suggestion: function(el){
          return '<p><span><img class="geocodeImagePlus" src="./images/Goodman_Plus_Search.svg"/>'+el + "</span></p>"}
      }
    });

    /* The typeahead has a nasty habit of deleting the selected value when it loses focus. This section
    attempts to workaroudn this */

    $('#txtSearch').bind('typeahead:select', function(ev, suggestion) {
      app.geoCodeValue = suggestion;

      // Remove any previous addresses
      app.markerLayer.removeAll();
      app.polygonLayer.removeAll();
      app.propertyLayer.definitionExpression = config.propertyLayerBaseQuery;
      app.view.popup.close();

      // Zoom to the selected address/feature
      if (app.geocodeResults.goodmanProperties[suggestion] !== undefined) {

        var pointGraphic = new Graphic({
          geometry: {
            type: "point",
            longitude: app.geocodeResults.goodmanProperties[suggestion][config.searchLayerLonField],
            latitude: app.geocodeResults.goodmanProperties[suggestion][config.searchLayerLatField]
          },
          symbol: app.goodmanSymbol
        });
        app.markerLayer.add(pointGraphic);

        app.startLocation = {
          "geometry":{
            "type": "point",
            "x": app.geocodeResults.goodmanProperties[suggestion][config.searchLayerLonField],
            "y": app.geocodeResults.goodmanProperties[suggestion][config.searchLayerLatField],
            "spatialReference": {
              "wkid": 4326
            }
          },
          "attributes": {
            "name": suggestion,
            "address": app.geocodeResults.goodmanProperties[suggestion]["address"],
            "countryCode": app.geocodeResults.goodmanProperties[suggestion]["countryCode"],
            "region": null
          },
          "mode": "Goodman"
        }
        app.startLocation.objectid = app.geocodeResults.goodmanProperties[suggestion]['objectid'];
        if (app.geocodeResults.goodmanProperties[suggestion].region !== undefined && app.geocodeResults.goodmanProperties[suggestion].region !== null){
          app.startLocation.attributes.region = app.geocodeResults.goodmanProperties[suggestion].region;
        }

        // Check that this location is not in a country where drive-time doesn't work
        checkDriveTimeAvailability();

        // Pan/zoom to show the property
        if (app.view.zoom < 15) {
          app.view.goTo({geometry: app.startLocation.geometry, zoom: 15})
        } else {
          app.view.goTo(app.startLocation);
        }

        // Display the Goodman Property popup
        var source = document.getElementById("property-popup-template2").innerHTML;
        var template = Handlebars.compile(source);
        var html = template(app.geocodeResults.goodmanProperties[suggestion]);
        app.view.popup.location = {
          latitude: app.geocodeResults.goodmanProperties[suggestion][config.searchLayerLatField],
          longitude: app.geocodeResults.goodmanProperties[suggestion][config.searchLayerLonField]
        }
        app.view.popup.title = '';
        app.view.popup.content = html;
        app.view.popup.open();

        // Enable Step 2
        enableStep(2);

      } else if (app.geocodeResults.addresses[suggestion] !== undefined) {
        // Geocode the suggestion from the Find Address Candidates service
        $.ajax({
          url: config.geocodeUrl + "&SingleLine=" + suggestion + "&magicKey=" + app.geocodeResults.addresses[suggestion]['magicKey'],
          // beforeSend: function () {
          //   // add required original suggestion so its countryCode can be accessed in the success function
          //   jqXHR.suggestion = suggestion;
          // },
          type: 'POST'
        }).done(function(response, textStatus, jqXHR) {
          var location = response.candidates[0].location;
          var pointGraphic = new Graphic({
            geometry: {
              type: "point",
              longitude: location.x,
              latitude: location.y
            },
            symbol: app.markerSymbol
          });
          app.markerLayer.add(pointGraphic);

          // Retrieve the country code from the original suggestion - it is the last parameter
          var countryCode3Digit = suggestion.split(", ")[suggestion.split(", ").length - 1];
          var countryCode2DigitObj = countryLookup.find(o => o ? o['alpha-3'] === countryCode3Digit: '');
          var countryCode2Digit = countryCode2DigitObj && countryCode2DigitObj["alpha-2"] || '';

          app.startLocation = {
            "geometry":{
              "type": "point",
              "x": location.x,
              "y": location.y,
              "spatialReference": {
                "wkid": 4326
              }
            },
            "attributes": {
              "name": response.candidates[0].address,
              "countryCode": countryCode2Digit,
              "region": null
              // "address": addr TODO
            },
            "mode": "address"
          }

          // Check that this location is not in a country where drive-time doesn't work
          checkDriveTimeAvailability();

          // Pan/zoom to show the property
          if (app.view.zoom < 15) {
            app.view.goTo({geometry: app.startLocation.geometry, zoom: 15})
          } else {
            app.view.goTo(app.startLocation);
          }

          // Display the generic address popup
          var source = document.getElementById("address-search-popup-template").innerHTML;
          var template = Handlebars.compile(source);
          var html = template({name: suggestion});
          app.view.popup.location = {
            latitude: location.y,
            longitude: location.x
          }
          app.view.popup.title = '';
          app.view.popup.content = html;
          app.view.popup.open();

          // Enable Step 2
          enableStep(2);

        }).fail(function(error) {
          console.error("There was a problem geocoding this value");
        });

      }

    });

    $('#txtSearch').bind('typeahead:close', function(ev) {
      $('#txtSearch').val(app.geoCodeValue);
    });

    $('#txtSearch').bind('typeahead:idle', function(ev) {
      $('#txtSearch').val(app.geoCodeValue);
    });

    // Reverse-geocode the address when clicking on the map
    app.viewClickListener = app.view.on("click", function(event) {
      viewClick(event);
    });

    // Add an image to the Traffic checkbox https://stackoverflow.com/a/10271065/906814
    // $('.input_class_checkbox').each(function(){
    //   $(this).hide().after('<div class="traffic_checkbox" />');
    // });

    // Handle the traffic dropdown availability (only in Car mode)
    $('.traffic_checkbox').on('click',function(){
      if (app.distanceMode === 'Truck'){
        return;
      }
      $(this).toggleClass('checked').prev().prop('checked',$(this).is('.checked'));
      $("#timeOfDay").toggleClass('disabled').prev().prop('disabled',$(this).is('.checked'));
      $("#cboDayOfWeek").prop("disabled", !$(this).is('.checked'));
      $("#cboTimeOfDay").prop("disabled", !$(this).is('.checked'));
    });

    $('#spanUseTraffic').on('click',function(){
      if (app.distanceMode === 'Truck'){
        return;
      }
      $(".traffic_checkbox").toggleClass('checked').prev().prop('checked',$(this).is('.checked'));
      $("#timeOfDay").toggleClass('disabled').prev().prop('disabled',$(this).is('.checked'));
      $("#cboDayOfWeek").prop("disabled", !$('.traffic_checkbox').is('.checked'));
      $("#cboTimeOfDay").prop("disabled", !$('.traffic_checkbox').is('.checked'));
    });

    // Check if this user has write access to SmartSpace, and enable the Save to SmartSpace functionality if so
    esriId.getCredential(config.portalUrl + "/sharing/rest").then(function (response) {
      console.log("got token", response.token);
      app.token = response.token;
      checkCanCreateService();
    });
  }

  function runTour() {
    // Configure the tour
    app.tour = new Tour(config.tour);

    // Initialize the tour
    localStorage.removeItem('tour_current_step');
    localStorage.removeItem('tour_end');
    app.tour.init();
    app.tour.start();
  }

  function runAddressSearch(inputAddress){
    if (inputAddress === undefined || inputAddress === null || inputAddress === '') {
      toastr.error("Please enter an address or Goodman property name");
      return null;
    }

    $("#txtSearch").typeahead('val', '')
    $("#txtSearch").focus().typeahead('val',inputAddress).focus();
  }

  function viewClick(event) {
    // When the user clicks on the view, set this location/property as the starting location

    if (app.tour !== undefined){app.tour.end();}
    app.markerLayer.removeAll();
    app.polygonLayer.removeAll();
    if (app.startLocation && app.startLocation.objectid !== undefined) {
      delete app.startLocation.objectid;
    }

    // See if the user clicked on a Goodman property, or on another location on the map
    app.view.hitTest(event).then(function (response) {

      // Determine whether a layer was found here
      var results = response.results;

      if (results.length > 0) {

        // Calculate the 2-digit country code from the country name
        var countryName = results[0].graphic.attributes[config.searchLayerCountryField] || '';
        var countryJSON = countryLookup.find(o => o.name === countryName);
        var countryCode = countryJSON ? countryJSON['alpha-2'] : '';
        
        // Set this location as the starting point for the drivetime/rings analysis. Use the lat/long from the attributes
        // in preference to the geometry
        let latitude = results[0].graphic.attributes.lat;
        let longitude = results[0].graphic.attributes.lon;
        if (!latitude){
          latitude = results[0].graphic.geometry.latitude;
        }
        if (!longitude){
          longitude = results[0].graphic.geometry.longitude;
        }

        let geometry = new Point({
          latitude: latitude,
          longitude: longitude
        })

        app.startLocation = {
          "geometry": geometry,
          "attributes": {
            "name": results[0].graphic.attributes[config.searchLayerNameField],
            "address": results[0].graphic.attributes.address,
            "countryCode": countryCode,
            "region": null
          },
          "mode": "Goodman"
        }

        // Check that this location is not in a country where drive-time doesn't work
        if (results[0].graphic.attributes.region !== undefined && results[0].graphic.attributes.region !== '') {
          app.startLocation.attributes.region = results[0].graphic.attributes.region;
        }
        checkDriveTimeAvailability();
        
        // Parse out the address
        for (var i = 0; i < config.layerAddressFields.length; i++){
          var addr = results[0].graphic.attributes[config.layerAddressFields[i]];
          if (addr !== undefined && addr !== null && addr !== '') {
            if (app.startLocation.attributes.address === null) {
              app.startLocation.attributes.address = addr;
            } else {
              app.startLocation.attributes.address += ", " + addr
            }
          }
        }

        // Show the name/address of the clicked location in the search box
        $("#txtSearch").val(app.startLocation.attributes.name);
        $("#txtSearch").off("click");
        $("#txtSearch").on("click", function(event) {
          $("#txtSearch").val("")
        });

        // Remember this facility's objectID, so we can filter out all other facilities
        app.startLocation.objectid = results[0].graphic.attributes['objectid'];

      } else {
        // Otherwise, show a marker and reverse-geocode to get the address at the location clicked
        var pointGraphic = new Graphic({
          geometry: event.mapPoint,
          symbol: app.markerSymbol
        });
        app.markerLayer.add(pointGraphic);

        // Reverse geocode
        var url = config.reversesuggestionsUrl + "?f=json&langCode=EN&location=" + event.mapPoint.longitude + "," + event.mapPoint.latitude
        esriRequest(url).then(function(response){
          try{

            var addr = response.data.address;
            var neighbourhood = addr.Neighborhood;
            var subRegion = addr.Subregion;
            var region = addr.Region;
            var countryCode = addr.CountryCode;
            var countryJSON = countryLookup.find(o => o["alpha-3"] === countryCode);
            if (countryJSON){
              countryCode = countryJSON['alpha-2'];
            }

            // Add the following address components if they exist
            var address = null;
            var components = [neighbourhood, subRegion, region];
            for (var i = 0; i < components.length; i++){
              var component = components[i];
              if (component !== '') {
                if (address === null) {
                  address = component;
                } else {
                  address += ", " + component;
                }
              }
            }

            app.view.popup.title = addr.ShortLabel;
            app.view.popup.content = address;
            app.view.popup.location = event.mapPoint;
            app.view.popup.open();

            // Set this location as the starting point for the drivetime/rings analysis
            app.startLocation = {
              "geometry": event.mapPoint,
              "attributes": {
                "name": addr.LongLabel,
                "address": address,
                "countryCode": countryCode,
                "region": null
              },
              "mode": "address"
            }

            // Check that this location is not in a country where drive-time doesn't work
            checkDriveTimeAvailability();

            // Show the name/address of the clicked location in the search box
            $("#txtSearch").val(app.startLocation.attributes.name);
            $("#txtSearch").off("click");
            $("#txtSearch").on("click", function(event) {
              $("#txtSearch").val("")
            });

          } catch(err) {
            // There was a problem with the geocoding, so cancel the ability to proceed until this is fixed
            app.markerLayer.removeAll();
            delete(app.startLocation);
            $(".btnStep2").attr("disabled", true);
            $(".btnStep2").addClass("disabled");
            $(".btnStep2").removeClass("btn-primary");
            console.error('Error encountered', err);
            toastr.error( "There was an error");
            $("#loading").hide();
          }
        }).catch((err) => {
          app.markerLayer.removeAll();
          delete(app.startLocation);
          $(".btnStep2").attr("disabled", true);
          $(".btnStep2").addClass("disabled");
          $(".btnStep2").removeClass("btn-primary");
          try{
            if (err.message === "Cannot perform query. Invalid query parameters."){
              toastr.error("That location is not valid. Please try another location");
              $("#loading").hide();
            }
          } catch(err){
            console.error('Error encountered', err)
            toastr.error("There was an error");
            $("#loading").hide();
          }
        });

      }

      // Zoom to the point clicked. This isn't working well since the popup may not be located exactly at the location clicked
      // var scale = Math.min(app.view.scale, config.zoomScale);

      // app.view.goTo({
      //   center: app.startLocation,
      //   scale: scale
      // });
      // app.view.popup.open();

      // Enable step 2. Remove the ability to click on the map
      enableStep(2);

    })

  }

  function checkDriveTimeAvailability() {
    // Drive Time calculations do not work in China (but does work in Hong Kon), so ensure that the option is disabled if required
    console.log("Check drive time availability")
    try{
      if (['CHN','CN'].includes(app.startLocation.attributes.countryCode)){
        if (app.startLocation.attributes.region !== null && app.startLocation.attributes.region === 'Hong Kong'){
          console.log("Hong Kong supports drive time")
          $("#drivetime-tab").removeClass('disabled');
          $("#drivetime-tab").removeAttr('disabled', 'disabled');
        } else {
          console.log("China. Disable drivetime");
          $("#ring-tab").trigger('click');
          $("#drivetime-tab").addClass('disabled');
          $("#drivetime-tab").attr('disabled', 'disabled');
          toastr.warning("Drive time is not available in this region");
        }
      } else {
        $("#drivetime-tab").removeClass('disabled');
        $("#drivetime-tab").removeAttr('disabled', 'disabled');
      }
    } catch(err){
      console.error("There was a problem checking whether this address supports drivetime calculations");
    }
  }

  function enableStep(stepNumber){
    // Enable this step, and disable any higher steps

    // Remove any unnecessary classes
    $(".step").removeClass('active');
    $("#step-" + stepNumber).removeClass('disabled');
    $(".btnStep" + stepNumber + ".primary").removeClass('btn-primary');
    $(".btnStep" + stepNumber + ".primary").removeClass('btn-secondary');
    $(".btnStep" + (stepNumber - 1) + ".primary").removeClass('btn-primary');
    $(".btnStep" + (stepNumber + 1) + ".primary").removeClass('btn-primary');
    $(".btnStep" + (stepNumber + 2) + ".primary").removeClass('btn-primary');
    $(".btnStep" + stepNumber).removeClass('disabled');
    $(".btnStep" + stepNumber).attr("disabled", false);

    // Downgrade any primary buttons in the previous step
    $(".btnStep" + (stepNumber - 1) + ".primary").addClass('btn-secondary');

    // Add new classes
    $(".btnStep" + stepNumber + ".secondary").addClass('btn-secondary');
    $(".btnStep" + stepNumber + ".primary").addClass('btn-primary');
    $("#step-" + (stepNumber + 1)).addClass('disabled');
    $("#step-" + (stepNumber + 2)).addClass('disabled');
    $(".btnStep" + (stepNumber + 1)).attr("disabled", true);
    $(".btnStep" + (stepNumber + 2)).attr("disabled", true);

    // Don't make Step 3 active as it results in too much colour
    if (stepNumber <= 2) {
      $("#step-" + stepNumber).addClass('active');
    }

    // Reset the view key stat button
    $("#btnCreateReport").removeClass("btn-blue").addClass('btn-clear');
  }

  function geoenrich(){
    $("#btnCreateReport").addClass("disabled btn-clear").removeClass('btn-blue');

    toastr.options.positionClass = "toast-center toast-with-backdrop toast-text-bolder toast-large toast-no-button";
    toastr.options.closeButton = false;
    toastr.options.timeOut = 0;
    toastr.options.extendedTimeOut = 0;
    toastr.info("Creating report...");
    // reset after any previous runs
    app.reportObj = undefined;

    // Format the study area, based on the ring(s) of the search area
    app.studyAreas = [];
    for (var i = 0; i < app.polygonLayer.graphics.items.length; i++){
      var attributes = app.polygonLayer.graphics.items[i].attributes;
      var name = "unknown";
      if (attributes['name'] !== undefined){
        name = attributes['name'];
      } else if (attributes['Name'] !== undefined){
        name = attributes['Name']
      }
      var geometry = app.polygonLayer.graphics.items[i].geometry;
      var wkid = geometry.spatialReference.wkid;
      var rings = geometry.rings;
      var obj = {
        "attributes": {
          "name": name
        },
        "geometry": {
          "rings": rings,
          "spatialReference": {
            "wkid": wkid
          }
        }
      }
      app.studyAreas.push(obj);
    }

    // Build the data object for the query
    var data = {
      "f": 'json',
      "returnGeometry": 'true',
      "studyAreas": JSON.stringify(app.studyAreas)
    }
    
    // Specify the variables to query in the GeoEnrichment Service - different parameters are used for the USA
    if (['US', 'USA'].includes(app.startLocation.attributes.countryCode)) {
      data.analysisVariables='["AtRisk.TOTPOP_CY", "AtRisk.TOTHH_CY", "AtRisk.AVGHHSZ_CY", "Clothing.X5063_X", "Clothing.X5001_X", "Food.X1003_X", "HealthPersonalCareCEX.X10002_X", \
       "SpendingTotal."X15001_X, "Wealth.AVGDI_CY", "Wealth.AGGDI_CY", "Wealth.WLTHINDXCY", "shopping.MP31099a_B", "5yearincrements.POP0_CY", \
        "5yearincrements.POP5_CY", "5yearincrements.POP10_CY", "5yearincrements.POP15_CY", "5yearincrements.POP20_CY", "5yearincrements.POP25_CY", \
        "5yearincrements.POP30_CY", "5yearincrements.POP35_CY", "5yearincrements.POP40_CY", "5yearincrements.POP45_CY", "5yearincrements.POP50_CY", \
        "5yearincrements.POP55_CY", "5yearincrements.POP60_CY", "5yearincrements.POP65_CY", "5yearincrements.POP70_CY", "5yearincrements.POP75_CY", \
        "5yearincrements.POP80_CY", "5yearincrements.POP85_CY"]';
    // } else if (['CA', 'CAN'].includes(app.startLocation.attributes.countryCode)) {
    //   data.analysisVariables='["FiveYearPopulationTotals.ECYPTAPOP]';
    } else {
      // var analysisVariables = '["15YearIncrements.*", "KeyFacts.TOTPOP_CY", "KeyFacts.TOTHH_CY", "KeyFacts.AVGHHSZ_CY", PurchasingPower.PPPC_CY", "PurchasingPower.PP_CY", "PurchasingPower.PPIDX_CY", \
      //   "Spending.CS05_CY", "Spending.CS04_CY", "Spending.CS01_CY", "Spending.CS13_CY", "Spending.CS12_CY", "Spending.CS19_CY"]';
      data.dataCollections ='["15YearIncrements", "KeyGlobalFacts", "PurchasingPower", "Spending"]';
    }

    $.ajax({
      url: config.geoenrichUrl,
      data: $.param(data),
      type: 'POST'
    }).done(function(response) {
      // app.geoenrichResponse = JSON.parse(response);
      if (typeof(response) !== 'object'){
        app.geoenrichResponse = JSON.parse(response);
      } else {
        app.geoenrichResponse = response;
      }
      if (app.geoenrichResponse.error !== undefined){
        closeGrowl();
        toastr.error("There was a problem displaying the report");
        console.error(app.geoenrichResponse.error);
      } else {
        console.log("Build the report");
        // Determine whether the report contains multiple countries/currencies
        var features = app.geoenrichResponse.results[0].value.FeatureSet[0].features;
        var countries = [];
        var currencies = [];
        
        features.forEach(feature => {
          var country = feature.attributes['sourceCountry'];
          if (!countries.includes(country)) {
            countries.push(country);
          }
          var currency = config.currency[country]
          feature.currency = currency;
          if (!currencies.includes(currency)){
            currencies.push(currency);
          }
        })
  
        // Build up an object which we can pass to the report. In the case of multiple countries, add the values together.
        // Separate reports are shown if the input geometry crosses country boundaries, or is confined to the USA.
        app.reportObj = {
          multiCurrency: (currencies.length > 1),
          USA: countries.includes("US"),
          CanadaOnly: countries.length === 1 && countries[0] === 'CA',
          auOnly: countries.length === 1 && countries[0] === 'AU'
        };
  
        // Fetch default currencies, plus any included currencies. Fetch all conversion factors in a single API call.
        // This function calls createReport when it's finished
        fetchCurrencyConversions();
  
      }

    }).fail(function(error) {
      console.error(error);
      $("#btnCreateReport").removeClass("disabled");
    });

  }

  function fetchCurrencyConversions(){
    // Check whether we already have the required currency conversions, to avoid overusing
    // the currency conversion API (this has a cost)
    app.geoenrichResponse.results[0].value.FeatureSet[0].features.forEach(feature => {
      var countryCode = feature.attributes['sourceCountry'];
      if (app.currencyConversions[countryCode] === undefined){
        app.currencyConversions[countryCode] = {
          currencyCode: config.currency[countryCode]
        }
      }      
    });

    var currencyCodes = Object.keys(app.currencyConversions).map(countryCode => {
      if (app.currencyConversions[countryCode]['rate'] === undefined) {
        return app.currencyConversions[countryCode]['currencyCode'];
      } else {
        return null;
      }
    });

    // Add the default currencies, available in all reports
    config.defaultCurrencies.forEach(currency => {
      if (!app.rates) {
        currencyCodes.push(currency)
      } else if (!app.rates[currency]) {
        currencyCodes.push(currency)
      // } else if (!currencyCodes.includes(currency)){
      //   currencyCodes.push(currency)
      }
    })
    
    if (currencyCodes.length > 0 && !currencyCodes.every(element => element === null)) {
      console.log("Fetching currency conversion factors");
    
      var url = config.fixerAPI + "?access_key=" + config.fixerKey + "&symbols=" + currencyCodes.toLocaleString();
      $.ajax({
        url: url,
        type: 'GET'
      }).done(function(response) {
        console.log("currency conversion:", response);
        if (response.error || !response.success) {
          console.error("There was a problem fetching currency conversions");
          createReport();

        } else {
          if (!app.rates){
            app.rates = response.rates;
          } else {
            Object.keys(response.rates).forEach(currency => {
              if (!app.rates[currency]) {
                app.rates[currency] = response.rates[currency];
              }
            })
          }
          //TODO: save the rates in a cookie to avoid duplicate fetching
          // createCookie("rates", app.rates, 1);
          var countryCodes = Object.keys(response.rates)
          countryCodes.forEach(countryCode => {
            var code2Digit = Object.keys(app.currencyConversions).find(key => app.currencyConversions[key].currencyCode === countryCode);
            if (code2Digit){
              var currencyCode = app.currencyConversions[code2Digit].currencyCode;
              var rate = app.rates[app.currencyConversions[code2Digit].currencyCode];
              app.currencyConversions[code2Digit].rate = rate;
            }
          })

          // Check for Australian online spend
          if (app.reportObj.auOnly) {
            console.log("Fetch australian online spend data");
    
            var studyAreaIdx = 0
            fetchOnlineSpend(studyAreaIdx);
    
          } else {
            createReport();
          }
        }
        

      }).fail(function(error){
        console.error("Currency conversion error:", error);
        $("#btnCreateReport").removeClass("disabled");

        // Fallback to the simple report without currency conversion
        app.reportObj.unSupportedCurrency = true;
        createReport();
      })
    } else {
      console.log("Using existing currency conversion factors")
      
      // Check for Australian online spend
      if (app.reportObj.auOnly) {
        console.log("Fetch australian online spend data");

        var studyAreaIdx = 0
        fetchOnlineSpend(studyAreaIdx);

      } else {
        createReport();
      }
    }

  }

  function fetchOnlineSpend(studyAreaIdx) {
    // Fetch the online spend dataset, then calculate the total online spend within this
    // study area (including proportional calculations where applicable)
    try{
      app.studyAreas[studyAreaIdx].auOnlineSpend = 0;

      this.polygon = new Polygon({
        rings: app.studyAreas[studyAreaIdx].geometry.rings,
        spatialReference: app.studyAreas[studyAreaIdx].geometry.spatialReference
      });
      
      // Figure out which Online Spend layer to query - meshblock, SA1 or SA2 - depending on the size of the polygon
      var polygonArea = geometryEngine.geodesicArea(this.polygon);
      var onlineSpendUrl;
      if (polygonArea < 100000000) {
        onlineSpendUrl = config.auOnlineSpend.meshblock;
      } else if (polygonArea < 500000000) {
        onlineSpendUrl = config.auOnlineSpend.sa1;
      } else {
        onlineSpendUrl = config.auOnlineSpend.sa2
      }
      var onlineSpendQueryTask = new QueryTask(onlineSpendUrl);
      var onlineSpendQuery = new Query();
      onlineSpendQuery.where = "1=1";
      onlineSpendQuery.outFields = [config.auOnlineSpend.onlineSpendField];
      onlineSpendQuery.returnGeometry = true;
      onlineSpendQuery.maxAllowableOffset = 0.0001;
      onlineSpendQuery.geometry = this.polygon;

      onlineSpendQueryTask.execute(onlineSpendQuery)
        .then(function(results){
          // If there were too many features, online spend can't be calculated for this study area
          if (results.exceededTransferLimit) {
            console.error("Exceeded transfer limit on this online query. Result cannot be calculated");
          } else {
            try{
              for (var r = 0; r < results.features.length; r++){
                var feature = results.features[r];
                var spend = feature.attributes[config.auOnlineSpend.onlineSpendField];

                // If this feature is not completely contained by the buffer,
                // calculate the proportional overlap
                try{
                  if (!geometryEngine.contains(this.polygon, feature.geometry)) {
                    var intersect = geometryEngine.intersect(this.polygon, feature.geometry);
                    var intersectArea = geometryEngine.geodesicArea(intersect, "square-kilometers");
                    var featureArea = geometryEngine.geodesicArea(feature.geometry, "square-kilometers");
                    var ratio = intersectArea / featureArea;
                    spend = ratio * spend;
                  }

                  app.studyAreas[studyAreaIdx].auOnlineSpend += spend;
                } catch(err){
                  console.error(err)
                }
              }

              // Write the result to the geoenrichment result object, so it can be displayed in the report
              app.geoenrichResponse.results[0].value.FeatureSet[0].features[studyAreaIdx].attributes["auOnlineSpend"] = app.studyAreas[studyAreaIdx].auOnlineSpend;

              console.log("total", studyAreaIdx, app.studyAreas[studyAreaIdx].auOnlineSpend);

            } catch(err){
              console.error(err.message)
              toastr.error("There was a problem calculating the Australian online spending for this location");
              createReport();
            }
          }

          // Fetch the next buffer polygon until there are no more, then create the report
          studyAreaIdx++;
          if (app.studyAreas[studyAreaIdx] !== undefined) {
            fetchOnlineSpend(studyAreaIdx)
          } else {
            createReport();
          }
        })
        .catch(function(error){
          toastr.error("There was a problem calculating the Australian online spending for this location");
          createReport();
          console.error(error.message);
        });
    } catch(err) {
      console.error(err.message)
      toastr.error("There was a problem calculating the Australian online spending for this location");
      createReport();
    }

  }

  function createReport(activeIndex){
    
    try{

        var response = {...app.geoenrichResponse};
        var features = response.results[0].value.FeatureSet[0].features;
        // console.log('create report', features)

        // iterate through all features to calculate the total population - required for proportional calculations
        app.totals = {};
        features.forEach(feature => {
          
          // For USA reports, convert TOTPOP_CY to TOTPOP for consistency
          if (feature.attributes['TOTPOP_CY']) {
            feature.attributes['TOTPOP'] = feature.attributes['TOTPOP_CY'];
          }

          // set the report's currency as the source country's currency
          if(!app.reportObj.reportCurrency) {
            app.reportObj.reportCurrency = config.currency[app.startLocation.attributes.countryCode]
            if (app.reportObj.reportCurrency === 'EUR'){
              app.reportObj.fromEuroRate = 1;
            } else {
              app.reportObj.fromEuroRate = app.currencyConversions[feature.attributes.sourceCountry].rate || 1;
            }
          }

          var name = feature.attributes['name'];
          if (app.totals[name] === undefined) {
            app.totals[name] = {
              numFeatures: 0,
              TOTPOP: 0,
              name: name
            };
          }

          if (feature.attributes['TOTPOP'] && feature.attributes['TOTPOP'] > 0) {
            app.totals[name]['TOTPOP'] += feature.attributes['TOTPOP'];
            app.totals[name]['numFeatures'] += 1;
          }
        });

        // Now iterate through the features again to calculate totals
        features.forEach(feature => {
          var name = feature.attributes['name'];

            if (feature.attributes.TOTPOP && feature.attributes.TOTPOP > 0) {
              for (var field in feature.attributes) {
                var value = feature.attributes[field];

                // Convert financial values to Euro, then convert them to the report's currency
                if (config.financialFields.includes(field)){
                  value = convertCurrency(feature, value);
                }

                if (!app.totals[name][field]){
                  if (config.fieldsToAverage.includes(field)){
                    app.totals[name][field] = (value * feature.attributes.TOTPOP);
                  } else if (config.fieldsToSum.includes(field)){
                    app.totals[name][field] = value;
                  }
                } else {
                  if (config.fieldsToAverage.includes(field)){
                    app.totals[name][field] += (value * feature.attributes.TOTPOP);
                  } else if (config.fieldsToSum.includes(field)){
                    app.totals[name][field] += value;
                  }
                }     
            }              
          }
        })

        // For averaged fields, calculate the population-weighted average
        Object.keys(app.totals).forEach(name => {
          config.fieldsToAverage.forEach(field => {
            app.totals[name][field] = Math.round(app.totals[name][field] / app.totals[name]["TOTPOP"] * 100) / 100;
          })
        });
        
        var reportIdx = 0;
        for (var b in app.totals){
          var band = app.totals[b];
          console.log(app.startLocation.attributes.name, app.startLocation.attributes.address);

          // Store the name and address of the starting location. Truncate the address if necessary      
          band['location'] = app.startLocation.attributes.name;
          if (app.startLocation.attributes.address !== undefined) {
            if (app.startLocation.attributes.address && app.startLocation.attributes.address.length <= 50){
              band['address'] = app.startLocation.attributes.address;
            } else if (!app.startLocation.attributes.address) {
              band['address'] = 'unknown address'
            } else {
              band['address'] = app.startLocation.attributes.address; //.substr(0, 40) + "...";
            }  
          // Set address to empty string is same as the location
          // } else if (app.startLocation.attributes.name) {
          //   band['address'] = app.startLocation.attributes.name; //.substr(0, 40) + "...";
          } else {
            band['address'] = '';
          }  
          // Update 16/8: Non goodman location dont need name, just address - converted from names
          if(app.startLocation.mode === 'address'){
            band['address'] = band['location'];
            band['location'] = '';
          }

          // Store the aliases so we can use them in the tooltips
          band['aliases'] = response.results[0].value.FeatureSet[0].fieldAliases;

          // Report if the result crosses multiple country boundaries
          band.multiCurrency = app.reportObj.multiCurrency;

          // // Lookup the currency
          // if (!app.reportObj.multiCurrency){
          //   band.currency = config.currency[response.results[0].value.FeatureSet[0].features[0].attributes.sourceCountry] || '$';
          // } else {
            band.currency = app.reportObj.reportCurrency;
          // }

          // Add the distance label
          band.label = "Within ";
          var distance;
          if (band.name.includes("buffer_")) {
            distance = band.name.replace("buffer_", "");
          } else if (band.name.includes(":")) {
            distance= band.name.substr(band.name.indexOf(" - ", band.name.indexOf(":") + 1) + 3, band.name.length);
          }

          band.label += distance;
          band.label += " " + app.distanceUnits.replace("mins", "minutes").replace("km", "kilometres");
          if (app.distanceMode === 'drivetime') {
            var mode = 'driving';
            if (app.vehicle === 'Truck') {
              mode = 'trucking';
            }
            band.label += " " + mode + " distance";
          }

          // Store the values
          app.reportObj[reportIdx] = band;
          reportIdx += 1;
        }

        // Take screenshot of the map so it can be inserted into the report as an image
        app.view.takeScreenshot({ area: { ignorePadding: false } }).then(function(screenshot) {
          var imageData = screenshot.data;
          var context = canvas.getContext("2d");
          context.putImageData(imageData, 0, 0);
          return;
        });

        // Show the report, selecting the first distance band
        // var firstResultIdx = Math.max(response.results[0].value.FeatureSet[0].features.length - 1, 0)
        if (activeIndex !== undefined) {
          showReport(activeIndex)
        } else {
          showReport(reportIdx - 1);
        }

        closeGrowl();
        $("#btnCreateReport").removeClass("disabled");

    } catch(err){
      toastr.error("There was a problem displaying the report for this location");
      console.error(err)
      $("#btnCreateReport").removeClass("disabled");
      closeGrowl();
    }

  }

  function showReport(idx) {
    // Create the report HTML from the appropriate Handlebars template
    var reportSource;
    if (app.reportObj.unSupportedCurrency || app.reportObj.CanadaOnly){
      reportSource = document.getElementById("report-mini-template").innerHTML;
    } else if (app.reportObj.USA) {
      reportSource = document.getElementById("report-usa-template").innerHTML;
    } else {
      reportSource = document.getElementById("report-template").innerHTML;
    }
    var reportTemplate = Handlebars.compile(reportSource);
    var html = reportTemplate(app.reportObj[idx]);
    $("#report").html(html);

    // Build the mini-map
    // Set dark grey theme basemap
    const mainMapBaseMap = app.webmap.basemap;
    const darkGreyBaseMap = app.basemapGallery.source.basemaps._items.find(b => b.title.toLowerCase() == '08 Dark grey canvas'.toLowerCase());
    app.miniMap = new Map({
      basemap: darkGreyBaseMap || mainMapBaseMap
    });

    var latitude, longitude;
    if (app.startLocation.geometry.latitude !== undefined) {
      latitude = app.startLocation.geometry.latitude;
      longitude = app.startLocation.geometry.longitude;
    } else if (app.startLocation.geometry.y !== undefined) {
      latitude = app.startLocation.geometry.y;
      longitude = app.startLocation.geometry.x;
    }
    app.miniMapView = new MapView({
      container: "miniMap",
      map: app.miniMap,
      center: [longitude, latitude],
      zoom: 15
    });
    app.miniMapView.ui.components = [];

    document.getElementById("btnPrint").onclick = function() {
      
      var miniPrint = $(this).hasClass("miniPrint");
      printElement(document.getElementById("printThis"), null, null, miniPrint);
    }

    // Export the modal to an image. https://stackoverflow.com/a/51415716/906814
    document.getElementById("btnExport").onclick = function() {
      console.log("Hook up export function")
      var miniPrint = $(this).hasClass("miniPrint");

      // var modal = $('#reportModal')[0];

      setTimeout(function() {
        // Take screenshot of the map so it can be inserted into the report as an image
        var options = { area: { ignorePadding: false }, width: miniPrint ? 660 : 340, height: miniPrint ? 390 : 196, quality: 100 };
        // if (app.reportObj.multiCurrency) {
        //   // export a larger map in the case of a multiCurrency report
        //   options.width = 789;
        //   options.height = 536;
        // }

        app.miniMapView.takeScreenshot(options).then(function(screenshot) {
          document.getElementById('imgMiniMapScreenshot').setAttribute('src', screenshot.dataUrl);
          $("#miniMap").css("display", "none");
          $("#reportDetailStatisticHeader").css("display", "none");
          $("#selPolygonsContainer").css("display", "none");
          $("#populationChart").css("display","none");
          $("#populationChartImg").css("display","block");
          $("#miniMapScreenshot").css("display", "block");
          $("#reportContainer").css("border-radius", "0px");
          html2canvas(document.getElementById('printThis'), {
            scale: 3,
            allowTaint: true,
            useCORS: true,
            useOverflow: true
          }).then(function(canvas) {
              downloadCanvas(document.getElementById('test'), canvas, 'Goodman SmartDrive.jpg');
              $("#miniMap").css("display", "flex");
              $("#selPolygonsContainer").css("display", "block");
              $("#populationChart").css("display","block");
              $("#populationChartImg").css("display","none");
              $("#miniMapScreenshot").css("display", "none");
              $("#reportContainer").css("border-radius", "12px");
          });
        }, 1000);
      });
    }

    function downloadCanvas(link, canvas, filename) {
        link.href = canvas.toDataURL();
        link.download = filename;
        link.click();
    }


    $('#reportModal').modal('show');

    // Manually add the distance bands to the dropdown
    for (var i = 3; i > -1; i--) {
      if (app.reportObj[i] !== undefined) {
        var name = app.reportObj[i].name;
        // Format the name for better appearance
        if (name.includes("buffer_")) {
          name = name.replace("buffer_", "");
        } else if (name.includes(":")) {
          name = name.substr(name.indexOf(" - ", name.indexOf(":") + 1) + 3, name.length);
        }

        name += " " + app.distanceUnits;
        var o = new Option(name, i);
        if (app.reportObj.selectedPolygon !== undefined) {
          if (app.reportObj.selectedPolygon === i) {
            o.selected = true;
          } else {

          }
        } else if (i === idx) {
          o.selected = true;
          app.reportObj.selectedPolygon = idx;
        }
        $(o).html(name);
        $("#selPolygons").append(o);
      }
    }

    // Set a listener to update the report when the dropdown is changed
    $('#selPolygons').off('change')
    $('#selPolygons').on('change', function(evt) {
      console.log('updating report');
      app.reportObj.selectedPolygon = parseInt(this.value)
      showReport(parseInt(this.value));
    });

    // Add the report's currencies
    if (app.rates){
      Object.keys(app.rates).forEach(name => {
        // var value = app.rates[name];
        var o = new Option(name, name);
        if (name === app.reportObj.reportCurrency) {
          o.selected = true;
        }
        $(o).html(name);
        $("#selCurrency").append(o);
        
      })
    }

    // Set a listener to update the report when the Currency dropdown is changed
    $('#selCurrency').off('change')
    $('#selCurrency').on('change', function(evt) {
      console.log('updating report with new currency');
      app.reportObj.reportCurrency = evt.target.value;
      app.reportObj.fromEuroRate = app.rates[evt.target.value];
      var index = app.reportObj.selectedPolygon || 0;
      createReport(index)
    });

    $(".delimit").each(function(i, obj) {
      var value = $(obj).data('value');
      var str;
      if (value > 1000000) {
        str = numeral(value).format('0.0a').replace("b", "bn");
      } else {
        str = numeral(value).format('0,0');
      }
      obj.textContent = str;
    });

    app.miniMapView.when(function(){
      // TODO: this is not working correctly and is breaking the main map's polygons

      // Add the applicable layer to the mini map
      app.miniMarkerLayer = new GraphicsLayer();
      var graphic = new Graphic({
        geometry: app.startLocation.geometry
      });
      if (app.startLocation.mode === 'Goodman') {
        graphic.symbol = {
          type: "picture-marker",
          url: config.squareIcon,
          width: "25px",
          height: "25px"
        }
      } else {
        graphic.symbol = {
          type: "picture-marker",
          url: "./images/Pin_" + app.markerColour + ".svg",
          width: "24px",
          height: "24px"
        }
      }
      app.miniMarkerLayer.graphics.add(graphic);
      app.miniPolygonLayer = new GraphicsLayer({
        opacity: 0.75
      });
      var graphics = app.polygonLayer.graphics.clone()
      app.miniPolygonLayer.graphics.add(graphics.items[idx]);
      app.miniMap.add(app.miniPolygonLayer);
      app.miniMap.add(app.miniMarkerLayer);
      app.miniMapView.goTo(app.miniPolygonLayer.graphics.items[0]);
      setTimeout(function(){
        // Zoom out slightly so the graphic prints (only for rings)
        if (app.distanceMode !== 'drivetime'){
          app.miniMapView.zoom = (app.miniMapView.zoom -1);
        }

      }, 400);
    });

    // Build the chart
    am4core.ready(function() {
      try{

        // Build the data object. USA has a different format to the rest of the world
        var chartData;
        if (app.reportObj.USA !== undefined && app.reportObj.USA) {
          chartData = [{
            "ageBand": "0-14",
            "population": ((app.reportObj[idx].POP0_CY  + app.reportObj[idx].POP5_CY + app.reportObj[idx].POP10_CY )/ app.reportObj[idx].TOTPOP) * 100
          }, {
            "ageBand": "15-29",
            "population": ((app.reportObj[idx].POP15_CY + app.reportObj[idx].POP20_CY + app.reportObj[idx].POP25_CY) / app.reportObj[idx].TOTPOP) * 100
          },
          {
            "ageBand": "30-44",
            "population": ((app.reportObj[idx].POP30_CY + app.reportObj[idx].POP35_CY + app.reportObj[idx].POP40_CY) / app.reportObj[idx].TOTPOP) * 100
          },
          {
            "ageBand": "45-59",
            "population": ((app.reportObj[idx].POP45_CY + app.reportObj[idx].POP50_CY + app.reportObj[idx].POP55_CY) / app.reportObj[idx].TOTPOP) * 100
          },
          {
            "ageBand": "60+",
            "population": ((app.reportObj[idx].POP60_CY + app.reportObj[idx].POP65_CY + app.reportObj[idx].POP70_CY + app.reportObj[idx].POP75_CY + app.reportObj[idx].POP80_CY + app.reportObj[idx].POP85_CY) / app.reportObj[idx].TOTPOP) * 100
          }];
        } else {
          chartData = [{
            "ageBand": "0-14",
            "population": (app.reportObj[idx].PAGE01_CY / app.reportObj[idx].TOTPOP) * 100
          }, {
            "ageBand": "15-29",
            "population": (app.reportObj[idx].PAGE02_CY / app.reportObj[idx].TOTPOP) * 100
          }, {
            "ageBand": "30-44",
            "population": (app.reportObj[idx].PAGE03_CY / app.reportObj[idx].TOTPOP) * 100
          }, {
            "ageBand": "45-59",
            "population": (app.reportObj[idx].PAGE04_CY / app.reportObj[idx].TOTPOP) * 100
          }, {
            "ageBand": "60+",
            "population": (app.reportObj[idx].PAGE05_CY / app.reportObj[idx].TOTPOP) * 100
          }];
        }

        am4core.useTheme(am4themes_animated);
        var chart = am4core.create("populationChart", am4charts.XYChart);

        // Add data
        chart.data = chartData;

        chart.paddingLeft = "0px";
        chart.paddingRight = "0px";

        chart.numberFormatter.numberFormat = "#.";
        
        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "ageBand";
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.fill = am4core.color("#c2c0cb");
        categoryAxis.renderer.labels.template.fontSize = "16px";
        categoryAxis.renderer.labels.template.fontFamily = "founders-grotesk-text-regular";
        categoryAxis.renderer.grid.template.strokeWidth = 0;
        categoryAxis.renderer.line.strokeWidth = 0;


        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.grid.template.strokeWidth = 0;
        valueAxis.renderer.labels.template.fill = am4core.color("#c2c0cb");
        valueAxis.renderer.labels.template.fontSize = "14px";
        valueAxis.renderer.labels.template.fontFamily = "founders-grotesk-text-regular";
        valueAxis.min = 0;
        valueAxis.renderer.baseGrid.disabled = true;

        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "population";
        series.dataFields.categoryX = "ageBand";
        series.name = "population";
        series.columns.template.paddingTop = 8;
        series.columns.template.fillOpacity = 1;
        series.columns.template.fill = am4core.color("#6e50ff");
        series.columns.template.stroke = am4core.color("#6e50ff");
        series.columns.template.width = am4core.percent(50);

        // Add value on top the graph
        var valueLabel = series.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.dy = 8;
        valueLabel.label.text = "{valueY}";
        valueLabel.label.fontSize = "12px";
        valueLabel.label.verticalCenter = "bottom";
        valueLabel.label.fontFamily = "founders-grotesk-text-medium";
        valueLabel.label.fill = am4core.color("#ffffff");

        setTimeout(function(){
          // Create an image version of the chart
          try{
            chart.exporting.getImage("png").then(function(imgData) {
              var img = document.getElementById('populationChartImg')
              if (img){
                img.setAttribute('src', imgData);
              } else {
                console.error("Image chart is not ready")
              }
            });
          } catch(err){
            console.error("There was a problem exporting the chart")
          }
        }, 1000);

      } catch(err) {
        console.error("There was an error with the population chart")
      }
    });

  }

  function convertCurrency(feature, value){
    try{
      // convert the value into Euros
      var toEuroRate;
      if (app.currencyConversions[feature.attributes.sourceCountry].currencyCode === 'EUR'){
        toEuroRate = 1;
      } else {
        toEuroRate = app.currencyConversions[feature.attributes.sourceCountry].rate;
      }
      var valueEuros = value / toEuroRate;

      // Convert the Euros to the target currency
      var valueTarget = valueEuros * app.reportObj.fromEuroRate;
      if (!valueTarget){
        app.reportObj.unSupportedCurrency = true;
      }
      return valueTarget;
    } catch{
      console.error("There was a problem converting currency")
    }
  }

  function animate(number, id){
    // var comma_separator_number_step = $.animateNumber.numberStepFactories.separator(',')
    var comma_separator_number_step = numeral(number).format('0.0')

    $('#' + id).animateNumber(
      {
        number: number,
        numberStep: comma_separator_number_step
      },
      {
        easing: 'swing',
        duration: 1500
      }
    );
  }

  function printElement(elem, append, delimiter, miniPrint) {
   // from https://stackoverflow.com/a/12181825/906814
   
    $("#populationChartImg").css("display","block");
    $("#populationChart").css("display","none");
    var domClone = elem.cloneNode(true);

    var $printSection = document.getElementById("printSection");

    if (!$printSection) {
        $printSection = document.createElement("div");
        $printSection.id = "printSection";
        document.body.appendChild($printSection);
    }

    if (append !== true) {
        $printSection.innerHTML = "";
    }

    else if (append === true) {
        if (typeof (delimiter) === "string") {
            $printSection.innerHTML += delimiter;
        }
        else if (typeof (delimiter) === "object") {
            $printSection.appendChild(delimiter);
        }
    }

    var options = { area: { ignorePadding: false }, width: miniPrint ? 660 : 340, height: miniPrint ? 390 : 196, quality: 100 };

    app.miniMapView
      .takeScreenshot(options)
      .then(function(screenshot) {
        domClone.querySelector('#imgMiniMapScreenshot').setAttribute('src', screenshot.dataUrl);
        setTimeout(function() {
          $printSection.appendChild(domClone);
          window.print();
          $("#populationChartImg").css("display","none");
          $("#populationChart").css("display","block");
        }, 1000);

      })
      .catch(function(e) {
        console.error('Error in getting map screenshot', e);
        $printSection.appendChild(domClone);
        window.print();
      })
  }


  function checkLayerName(layerName){
    // generate a token
    try{
      esriId.getCredential(config.portalUrl + "/sharing/rest").then(function (response) {
        console.log("got token", response.token);
        app.token = response.token;
        app.userId = response.userId;

        // Check whether layer name is unique in SmartSpace
        var url = config.portalUrl + "/sharing/rest/portals/" + config.portalHash + "/isServiceNameAvailable?name="+ layerName + "&type=Feature%20Service&f=json"
        url += "&token=" + app.token;
        $.ajax({
          url: url,
          type: 'GET',
          datatype: 'json',
          contentType: 'application/x-www-form-urlencoded',
          crossDomain: true,
          beforeSend: function (jqXHR) {
            jqXHR.layerName = layerName;
          },
        }).done(function(response, status, jqXHR) {
          try{
            if (response.available === true){
              $('#saveToSmartSpaceModal').modal('hide');
              toastr.options.positionClass = "toast-center toast-with-backdrop toast-text-bolder toast-large toast-no-button";
              toastr.options.closeButton = false;
              toastr.options.timeOut = 0;
              toastr.options.extendedTimeOut = 0;
              toastr.info("Creating layer...");
              createService(jqXHR.layerName)
            } else {
              var errMessage = "Layer name is not unique";
              console.error(errMessage);
              toastr.error(errMessage);
            }
          } catch(error) {
            console.error("There was a problem verifying that the layer name is unique")
            toastr.error("There was a problem verifying that the layer name is unique");
          }
        }).fail(function(error){
          console.error(error);
        });

      }).catch(function(err){
        console.error("There was a problem generating a token", err)
        toastr.error("There was a problem generating a secure token");
      })
    }catch(err){
      console.error("There was a problem generating a token")
      toastr.error("There was a problem generating a secure token");
    }

  }

  function createService(layerName){
    console.log("Create new empty layer", layerName);
    var url = config.portalUrl + "/sharing/rest/content/users/" + app.userId + "/createService";
    url += "?token=" + app.token;

    var data = {
      createParameters: JSON.stringify({
        "name": layerName,
        "description": "Layer created by SmartDrive",
        "capabilities": "Create,Delete,Query,Update,Editing",
        "allowGeometryUpdates" : true,
        "units" : "esriMeters",
        "xssPreventionInfo" : {
          "xssPreventionEnabled" : true,
          "xssPreventionRule" : "input",
          "xssInputRule" : "rejectInvalid"
        }
      }),
      outputType: "featureService",
      f: "json",
      token: app.token
    }

    $.ajax({
      url: url,
      type: 'POST',
      data: data,
      datatype: 'json',
      contentType: 'application/x-www-form-urlencoded',
      crossDomain: true,
      beforeSend: function (jqXHR) {
        jqXHR.layerName = layerName;
      },
    }).done(function(response, status, jqXHR) {
      try{

        // If the new service was successfully created, add the layer definition
        if (response.success === true){
          addToDefinition(jqXHR.layerName, response.serviceurl, response.serviceItemId);
        } else {
          closeGrowl();
          toastr.error("There was a problem creating the new layer");
          $('#saveToSmartSpaceModal').modal('hide');
          if (response.error !== undefined && response.error.message !== undefined) {
            console.error(response.error.message);
          }
        }
      }catch(error){
        closeGrowl();
        toastr.error("There was a problem creating the new layer");
        $('#saveToSmartSpaceModal').modal('hide');
      }

    }).fail(function(error){
      console.error(error);
    });

  }

  function addToDefinition(layerName, layerUrl, itemId) {
    // https://developers.arcgis.com/rest/services-reference/add-to-definition-feature-service-.htm
    var data = {
      "addToDefinition": JSON.stringify({
        "layers": [
          {
            "name": layerName,
            "id": 0,
            "geometryType": "esriGeometryPolygon",
            "extent": app.view.extent,
            "hasM": false,
            "hasZ": false,
            "type": "Feature Layer",
            "objectIdField": "objectid",
            "fields": [
              {
                "name": "objectid",
                "type": "esriFieldTypeOID",
                "alias": "objectid",
                "editable": false,
                "nullable": false
              },
              {
                "name": "name",
                "type": "esriFieldTypeString",
                "alias": "name",
                "editable": true,
                "nullable": true,
                "length": 1024
              },
              {
                "name": "start",
                "type": "esriFieldTypeString",
                "alias": "start location",
                "editable": true,
                "nullable": true,
                "length": 1024
              },
              {
                "name": "address",
                "type": "esriFieldTypeString",
                "alias": "address",
                "editable": true,
                "nullable": true,
                "length": 1024
              },
              {
                "name": "countrycode",
                "type": "esriFieldTypeString",
                "alias": "country code",
                "editable": true,
                "nullable": true,
                "length": 10
              },
              {
                "name": "frombreak",
                "type": "esriFieldTypeInteger",
                "alias": "from break",
                "editable": true,
                "nullable": true
              },
              {
                "name": "tobreak",
                "type": "esriFieldTypeInteger",
                "alias": "to break",
                "editable": true,
                "nullable": true
              },
              {
                "name": "distancemode",
                "type": "esriFieldTypeString",
                "alias": "distance mode",
                "editable": true,
                "nullable": true,
                "length": 10
              },
              {
                "name": "distanceunits",
                "type": "esriFieldTypeString",
                "alias": "distance units",
                "editable": true,
                "nullable": true,
                "length": 10
              },
            ],
            "allowGeometryUpdates": true,
            "displayField": "name",
            "description": "",
            "copyrightText": "Goodman",
            "defaultVisibility": true,
            "relationships": null,
            "hasAttachments": false,
            "htmlPopupType": "esriServerHTMLPopupTypeNone",
            "supportedQueryFormats": "JSON, geoJSON",
            "capabilities": "Create,Editing,Query,Update,Uploads,Delete,Extract",
            "indexes": [],
            "drawingInfo": {
              "renderer": {
                "symbol": {
                  "color": [
                    76,
                    0,
                    115,
                    255
                  ],
                  "style": "esriSFSSolid",
                  "type": "esriSFS",
                  "outline": {
                  "color": [
                    218,
                    112,
                    214,
                    255
                  ],
                  "width": 1,
                  "style": "esriSLSSolid",
                  "type": "esriSLS"
                  }
                },
                "type": "simple"
              },
              "transparency": 50
            },
            "maxRecordCount": 2000,
            "serviceItemId": itemId
          }
        ]
      }),
      "f": "json",
      "token": app.token
    }

    // Ensure we are using HTTPS if applicable
    if (window.location.protocol === 'https:') {
      layerUrl = layerUrl.replace('http:', 'https:')
    }

    // Use the Admin REST routes
    var url = layerUrl.replace("/rest/services/", "/rest/admin/services/");
    url += "/addToDefinition";

    $.ajax({
      url: url,
      type: 'POST',
      data: data,
      datatype: 'jsonp',
      contentType: 'application/x-www-form-urlencoded',
      crossDomain: true,
      beforeSend: function (jqXHR) {
        jqXHR.layerName = layerName;
        jqXHR.layerUrl = layerUrl;
        jqXHR.itemId = itemId;
      },
    }).done(function(response, status, jqXHR) {
      if (response.success) {
        // Add description and tags
        updateDetails(jqXHR.layerUrl, jqXHR.itemId, jqXHR.layerName);
      } else {
        closeGrowl();
        toastr.error("There was a problem saving the polygons");
        console.error("There was a problem creating the new Layer", response)
      }
    }).fail(function(error) {
      closeGrowl();
      toastr.error("There was a problem saving the polygons");
    });
  }

  function updateDetails(layerUrl, itemId, layerName) {
    // Update the description and tags for the new item. These are now hard-coded

    var data = {
      // description: $("#txtSmartSpaceDescription").val(),
      // tags: $("#txtSmartSpaceTags").val()
      description: "Polygons created by SmartDrive",
      tags: "Drive times"
    }

    var url = config.portalUrl + "/sharing/rest/content/users/" + app.userId + "/items/" + itemId + "/update?f=json&token=" + app.token;

    $.ajax({
      url: url,
      data: data,
      type: 'POST',
      datatype: 'json',
      contentType: 'application/x-www-form-urlencoded',
      beforeSend: function (jqXHR) {
        jqXHR.layerName = layerName;
        jqXHR.layerUrl = layerUrl;
        jqXHR.itemId = itemId;
      },
    }).done(function(response, status, jqXHR) {
      exportToSmartSpace(jqXHR.layerName, jqXHR.layerUrl, jqXHR.itemId)
    }).fail(function(error){
      console.error("There was a problem updating the details and tags", error)
    })

  }

  function exportToSmartSpace(layerName, layerUrl, itemId) {

    // Send the polygon(s) to the new layer which was previously created. This will always be index 0 since
    // we only just created the layer
    var url = layerUrl + '/0/addFeatures?f=json&token=' + app.token;

    var features = []
    for (var p = 0; p < app.polygonLayer.graphics.items.length; p++){
      var polygon = app.polygonLayer.graphics.items[p];

      // Add attributes from the drivetime polygon to the output layer polygon
      polygon.attributes['start'] = app.startLocation.attributes['name'];
      polygon.attributes['address'] = app.startLocation.attributes['address'];
      polygon.attributes['countrycode'] = app.startLocation.attributes['countryCode'];
      polygon.attributes['frombreak'] = polygon.attributes['FromBreak'];
      polygon.attributes['tobreak'] = polygon.attributes['ToBreak'];
      polygon.attributes['distancemode'] = app.distanceMode;
      polygon.attributes['distanceunits'] = app.distanceUnits;
      features.push({"geometry": polygon.geometry, "attributes": polygon.attributes})
    }

    var data = {
      features: JSON.stringify(features)
    };

    $.ajax({
      url: url,
      data: $.param(data),
      type: 'POST',
      datatype: 'json',
      contentType: 'application/x-www-form-urlencoded',
      beforeSend: function (jqXHR) {
        jqXHR.layerUrl = layerUrl;
        jqXHR.itemId = itemId;
      },
    }).done(function(response, status, jqXHR) {
      try{
        if (response.addResults !== undefined){
          toastr.clear();
          toastr.options.closeButton = true;

          const url = config.portalUrl + "/home/item.html?id=" + jqXHR.itemId;
          
          const successToastr = toastr.success("Successfully saved the polygons to SmartSpace (click here to access the layer)");

          successToastr[0].addEventListener("click", () => {
            window.open(url, '_blank');
          });

        } else {
          closeGrowl();
          toastr.error("There was a problem saving the polygons");
        }
      } catch(err){
        closeGrowl();
        toastr.error("There was a problem saving the polygons");
      }
    }).fail(function(error){
      closeGrowl();
      console.error(error);
      toastr.error("There was a problem saving the polygons");
    });
  }

  function checkCanCreateService(){
    try{

      var url = config.reverseProxy + config.portalUrl + '/admin/services/canCreateService';
      url += "?f=json&serviceType=FeatureServer&token=" + app.token;

      data = {
        "f": "json",
        "serviceType": "FeatureServer"
      }

      $.ajax({
        url: url,
        data: JSON.stringify(data),
        type: 'POST',
        crossDomain: true,
        dataType: 'json',
        contentType: 'application/x-www-form-urlencoded',
      }).done(function(response, status) {
        if (response.status !== undefined && response.status === 'success'){
          app.saveToSmartSpace = true;
        }
      }).fail(function(error){
        console.error("There was a problem checking the user's write status to SmartSpace")
      })
    } catch(error){
      console.error("This user cannot access the Save To SmartSpace functionality");
    }
  }

  function createCookie(name, value, days) {
    var expires;
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
    }
    else {
      expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  function getCookie(c_name) {
    if (document.cookie.length > 0) {
      c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        c_end = document.cookie.indexOf(";", c_start);
        if (c_end == -1) {
            c_end = document.cookie.length;
        }
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return "";
  }

  function setupTourSplash() {

    // Show the tour if this is the first time the user has visited the site
    app.showTour = localStorage.getItem('SmartDrive_showTourOnStartup');

    $('#goodmanCheckBoxInput').attr('checked', app.showTour === "false" ? false : true);

    if (app.showTour === null){
      localStorage.setItem('SmartDrive_showTourOnStartup', "true");
      $("#tourSplash").modal('show');
    } else if (app.showTour === "true") {
      $("#tourSplash").modal('show');
    } else {
      localStorage.setItem('SmartDrive_showTourOnStartup', "false");
    }
    
    $('#tourStart').on('click',function() {
      $("#tourSplash").modal('hide');
      runTour();
    })

    $('#tourGlossary').on('click',function(e) {
      e.preventDefault();
      window.open('https://www.goodman.com/SmartDrive-glossary','_blank');
      $('#tourGlossary').blur();
    })

    $('#goodmanCheckBoxInput').on('change',function() {
      localStorage.setItem('SmartDrive_showTourOnStartup',`${this.checked}`)
    })
  }

  function mockSaveToSmartSpace() {
    setTimeout(() => {
      $('#saveToSmartSpaceModal').modal('hide');
      toastr.options.positionClass = "toast-center toast-with-backdrop toast-text-bolder toast-large toast-no-button";
      toastr.options.closeButton = false;
      toastr.options.timeOut = 0;
      toastr.options.extendedTimeOut = 0;
      toastr.info("Creating layer...");


      setTimeout(() => {
        toastr.clear();
        
        toastr.options.closeButton = true;
        
        const successToastr = toastr.success("Successfully saved the polygons to SmartSpace (click here to access the layer)");
        toastr.options.tapToDismiss = false;

        successToastr[0].addEventListener("click", () => {
          window.open("https://www.google.com", '_blank');
        });

      }, 5000)
    }, 1000);
  }
});

$(document).ready(function() {
  $('.select-wrapper select').select2({
    width: '100%',
    dropdownCssClass: 'drop-class',
    selectionCssClass: 'select-class'
  });
});